function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M124.48 68.25H124.14V196.9H218.14V68.25C218.154 62.0686 216.949 55.9451 214.594 50.2301C212.238 44.5151 208.779 39.3209 204.413 34.9449C200.047 30.5689 194.861 27.097 189.151 24.7282C183.442 22.3593 177.321 21.14 171.14 21.14C159.708 21.1484 148.67 25.3233 140.095 32.8831C131.519 40.4428 125.992 50.8692 124.55 62.21V62.34C124.302 64.3003 124.175 66.2741 124.17 68.25H124.48Z",
  fill: "#F2F2F2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2026 40.9329L67.4322 49.6424C65.8799 50.4032 65.2383 52.2782 65.9991 53.8305C66.7599 55.3827 68.6349 56.0243 70.1872 55.2636L87.9576 46.5541C89.5099 45.7933 90.1515 43.9182 89.3907 42.366C88.6299 40.8137 86.7549 40.1721 85.2026 40.9329Z",
  fill: "#002766"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M92.5199 79.3401C102.676 79.3401 110.91 71.1066 110.91 60.9501C110.91 50.7935 102.676 42.5601 92.5199 42.5601C82.3634 42.5601 74.1299 50.7935 74.1299 60.9501C74.1299 71.1066 82.3634 79.3401 92.5199 79.3401Z",
  fill: "#002766"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M83.0202 28.9816L82.6368 48.7679C82.6033 50.4963 83.9773 51.9245 85.7056 51.958C87.4339 51.9915 88.8621 50.6175 88.8956 48.8892L89.279 29.1029C89.3125 27.3746 87.9385 25.9464 86.2102 25.9129C84.4819 25.8794 83.0537 27.2533 83.0202 28.9816Z",
  fill: "#002766"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M92.8304 29.0872L81.6212 45.3967C80.6421 46.8213 81.0033 48.7699 82.4279 49.749C83.8525 50.7282 85.8012 50.367 86.7803 48.9424L97.9894 32.6329C98.9686 31.2083 98.6074 29.2597 97.1828 28.2806C95.7582 27.3014 93.8095 27.6626 92.8304 29.0872Z",
  fill: "#002766"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M73.6836 35.5683L87.4035 49.8304C88.602 51.0761 90.5834 51.1145 91.8292 49.9161C93.075 48.7177 93.1134 46.7362 91.9149 45.4904L78.195 31.2283C76.9966 29.9826 75.0151 29.9442 73.7693 31.1426C72.5236 32.341 72.4852 34.3225 73.6836 35.5683Z",
  fill: "#002766"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M87.15 200.7L64.72 276.24",
  stroke: "#38B8E0",
  strokeWidth: 17.81,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M117.34 196.9L134.91 287.56",
  stroke: "#38B8E0",
  strokeWidth: 17.81,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M125.1 236.96L127 246.78",
  stroke: "#C0EFFF",
  strokeWidth: 17.81,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M41.31 176.24C40.87 177.04 40.46 177.87 40.1 178.71C39.88 179.21 39.7 179.84 40.05 180.25",
  stroke: "black",
  strokeWidth: 0.31,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M38.5901 177.93C34.8701 180.83 33.3701 188.72 28.8601 187.93C24.6401 187.23 31.2801 173.71 33.3701 169.52C34.5001 167.27 36.9801 166.97 39.3701 168.02C41.7601 169.07 42.2701 175 38.5901 177.93Z",
  fill: "#C0EFFF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M39.1899 181.77L42.1999 172.38",
  stroke: "#C0EFFF",
  strokeWidth: 2.81,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M31.12 179.33C29.61 180.83 28.49 187.6 28.49 187.6",
  stroke: "black",
  strokeWidth: 0.31,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M34.12 179.33C32.62 180.83 31.49 187.6 31.49 187.6",
  stroke: "black",
  strokeWidth: 0.31,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M110.85 98.37C120.62 105.51 127 112.84 144.98 114.68",
  stroke: "#38B8E0",
  strokeWidth: 10.31,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M106.3 136.24L87.3601 199.98",
  stroke: "#38B8E0",
  strokeWidth: 17.81,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M78.1899 134.09L117.34 196.9",
  stroke: "#38B8E0",
  strokeWidth: 17.81,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M106.3 136.24L91.54 185.94",
  stroke: "#1B4D89",
  strokeWidth: 25,
  strokeMiterlimit: 10
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M78.1899 134.09L109.62 191.58",
  stroke: "#1F75DB",
  strokeWidth: 25,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M121.18 136.5C121.18 151.86 65.5801 151.86 65.5801 136.5C65.5801 129.127 68.509 122.056 73.7225 116.842C78.936 111.629 86.0071 108.7 93.3801 108.7C100.753 108.7 107.824 111.629 113.038 116.842C118.251 122.056 121.18 129.127 121.18 136.5Z",
  fill: "#1F75DB"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M71.4901 96.12L52.3401 140.07",
  stroke: "#38B8E0",
  strokeWidth: 10.31,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M51.9701 140.82L38.8201 170.88",
  stroke: "#38B8E0",
  strokeWidth: 10.31,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M152.77 67.09C152.77 66.17 152.7 65.25 152.61 64.34C152.55 63.8 152.4 63.16 151.89 62.98",
  stroke: "black",
  strokeWidth: 0.31,
  strokeMiterlimit: 10
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M154.31 64.2801C156.11 59.9201 153.31 50.8401 157.84 50.7501C163 50.6501 162.73 64.3301 163 69.0001C163.13 71.5201 161.11 73.0001 158.51 73.2601C155.91 73.5201 152.52 68.6001 154.31 64.2801Z",
  fill: "#38B8E0"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M151.89 61.23L153.89 70.89",
  stroke: "#38B8E0",
  strokeWidth: 2.81,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M145 114.68C152.79 98.37 157.59 70.53 157.59 70.53",
  stroke: "#38B8E0",
  strokeWidth: 10.31,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M86.3142 99.3147L75.5696 116.278C74.4584 118.033 72.6958 119.274 70.6696 119.728C68.6433 120.183 66.5194 119.814 64.7651 118.703L59.9075 115.626C58.1532 114.515 56.9121 112.753 56.4573 110.726C56.0026 108.7 56.3713 106.576 57.4825 104.822L65.7871 91.7107C66.6551 90.3331 67.7863 89.1401 69.1159 88.2003C70.4456 87.2604 71.9476 86.5921 73.5359 86.2336C75.1243 85.8751 76.7677 85.8334 78.3722 86.111C79.9766 86.3886 81.5106 86.98 82.8861 87.8512L83.8999 88.4934C85.6542 89.6045 86.8953 91.3671 87.3501 93.3934C87.8049 95.4196 87.4361 97.5435 86.3249 99.2979L86.3142 99.3147Z",
  fill: "#0E3163"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M119.9 142.54L67.9 143.85C66.18 143.85 64.95 141.95 64.95 139.61L66.81 99.55C66.81 91.8 71.62 85.55 80.81 85.55H105.56C109.14 85.55 119.32 95.8 119.32 103.55L122.13 138.33C122.14 140.64 121.19 142.54 119.9 142.54Z",
  fill: "#0E3163"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M109.079 86.5763L124.753 97.7993C125.5 98.3346 126.004 99.145 126.155 100.052C126.305 100.959 126.088 101.889 125.553 102.637L117.166 114.349C116.631 115.097 115.82 115.601 114.913 115.751C114.006 115.901 113.077 115.685 112.329 115.15L94.2822 102.227C93.5346 101.692 93.0303 100.881 92.8801 99.9743C92.73 99.0671 92.9464 98.1375 93.4818 97.3899L100.175 88.0425C101.159 86.6676 102.65 85.7402 104.318 85.4641C105.986 85.188 107.696 85.586 109.071 86.5705L109.079 86.5763Z",
  fill: "#0E3163"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6299 60.0601H87.7999V65.2501C87.7973 65.2929 87.7828 65.3341 87.758 65.3691C87.7332 65.404 87.6991 65.4314 87.6596 65.448C87.6201 65.4647 87.5767 65.4699 87.5344 65.4632C87.492 65.4565 87.4524 65.4381 87.4199 65.4101C87.0146 65.0309 86.5071 64.7789 85.9601 64.685C85.4131 64.5912 84.8506 64.6597 84.3421 64.882C83.8336 65.1043 83.4014 65.4708 83.0989 65.9361C82.7964 66.4014 82.6368 66.9451 82.6399 67.5001C82.6386 67.8747 82.7114 68.2459 82.8542 68.5923C82.9969 68.9386 83.2068 69.2534 83.4717 69.5183C83.7367 69.7832 84.0514 69.993 84.3977 70.1358C84.7441 70.2786 85.1153 70.3514 85.4899 70.3501H87.6899C87.7191 70.3501 87.7471 70.3616 87.7677 70.3823C87.7884 70.4029 87.7999 70.4309 87.7999 70.4601V87.0001C87.79 87.1732 87.79 87.3469 87.7999 87.5201C87.8578 88.4601 88.2599 89.3458 88.9295 90.0081C89.5992 90.6703 90.4893 91.0627 91.4299 91.1101C92.4639 91.0532 93.433 90.5886 94.1248 89.8181C94.8166 89.0476 95.1745 88.0341 95.1199 87.0001V82.5001C95.938 82.7223 96.7822 82.8333 97.6299 82.8301H98.2199C100.673 82.8301 103.026 81.8555 104.761 80.1208C106.495 78.3861 107.47 76.0333 107.47 73.5801V60.0601H97.6299Z",
  fill: "#38B8E0"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M95.5201 67.65C97.569 67.65 99.2301 65.989 99.2301 63.94C99.2301 61.891 97.569 60.23 95.5201 60.23C93.4711 60.23 91.8101 61.891 91.8101 63.94C91.8101 65.989 93.4711 67.65 95.5201 67.65Z",
  fill: "#C0EFFF"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M97.2172 62.2008L94.4478 62.1472C93.6416 62.1316 92.9754 62.7724 92.9598 63.5786C92.9441 64.3848 93.585 65.051 94.3912 65.0666L97.1607 65.1203C97.9669 65.1359 98.6331 64.495 98.6487 63.6888C98.6643 62.8827 98.0234 62.2165 97.2172 62.2008Z",
  fill: "white"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M102.455 68.9811L99.5255 68.9244C98.7635 68.9096 98.1338 69.5154 98.119 70.2774L98.1159 70.4374C98.1012 71.1994 98.7069 71.8291 99.4689 71.8438L102.398 71.9006C103.16 71.9154 103.79 71.3096 103.805 70.5476L103.808 70.3876C103.823 69.6256 103.217 68.9959 102.455 68.9811Z",
  fill: "#C0EFFF"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M88.8101 83.2401C90.8591 83.2401 92.5201 81.579 92.5201 79.5301C92.5201 77.4811 90.8591 75.8201 88.8101 75.8201C86.7611 75.8201 85.1001 77.4811 85.1001 79.5301C85.1001 81.579 86.7611 83.2401 88.8101 83.2401Z",
  fill: "#C0EFFF"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M104.52 67.3501C106.569 67.3501 108.23 65.689 108.23 63.6401C108.23 61.5911 106.569 59.9301 104.52 59.9301C102.471 59.9301 100.81 61.5911 100.81 63.6401C100.81 65.689 102.471 67.3501 104.52 67.3501Z",
  fill: "#C0EFFF"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M105.669 62.0148L103.429 61.9714C102.623 61.9558 101.957 62.5967 101.941 63.4028C101.926 64.209 102.567 64.8752 103.373 64.8908L105.612 64.9342C106.419 64.9499 107.085 64.309 107.1 63.5028C107.116 62.6966 106.475 62.0304 105.669 62.0148Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M101.66 65.55L102.29 65.9L102.56 66.04C102.683 66.1009 102.792 66.1863 102.88 66.291C102.969 66.3958 103.035 66.5175 103.074 66.6488C103.114 66.7801 103.125 66.9181 103.109 67.0542C103.093 67.1903 103.049 67.3217 102.98 67.44C102.919 67.5629 102.834 67.6719 102.729 67.7603C102.624 67.8488 102.503 67.9147 102.371 67.9541C102.24 67.9935 102.102 68.0055 101.966 67.9893C101.83 67.9731 101.698 67.9291 101.58 67.86V67.86",
  stroke: "black",
  strokeWidth: 0.31,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M97.2899 65.07C98.0631 65.07 98.6899 64.4432 98.6899 63.67C98.6899 62.8968 98.0631 62.27 97.2899 62.27C96.5167 62.27 95.8899 62.8968 95.8899 63.67C95.8899 64.4432 96.5167 65.07 97.2899 65.07Z",
  fill: "#1D1D1B"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M105.81 64.9C106.583 64.9 107.21 64.2732 107.21 63.5C107.21 62.7268 106.583 62.1 105.81 62.1C105.037 62.1 104.41 62.7268 104.41 63.5C104.41 64.2732 105.037 64.9 105.81 64.9Z",
  fill: "#1D1D1B"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M97.29 69.36C98.23 70.09 101.44 70.81 102.98 70.18",
  stroke: "black",
  strokeWidth: 0.31,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M153.89 87.75L150.56 99.86",
  stroke: "#C0EFFF",
  strokeWidth: 10.31,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M123.28 277.29L122.46 308.43L132.69 308.69L128.24 296.56C128.573 296.529 128.907 296.529 129.24 296.56L134.49 308.03C134.61 308.242 134.782 308.42 134.991 308.546C135.199 308.672 135.437 308.742 135.68 308.75L180.1 309.91C180.22 305.14 146.65 293.69 146.79 288.12C146.79 288.12 147.01 277.89 147.06 277.89L123.28 277.29Z",
  fill: "#0E3163"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M48.3101 298.59L54.5001 301.84L55.1401 289.74L55.8001 289.89L56.1601 302.41L71.4201 309.52L98.0701 309.93C98.8201 308.16 88.8301 304.33 80.8501 300.52C74.0401 297.27 74.7801 278.12 75.6601 276.04L54.5001 268.89L48.3101 298.59Z",
  fill: "#0E3163"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M87.1499 199.98L81.1599 220.14",
  stroke: "#C0EFFF",
  strokeWidth: 17.81,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M251.22 100C268.86 100 283.16 85.7 283.16 68.06C283.16 50.42 268.86 36.12 251.22 36.12C233.58 36.12 219.28 50.42 219.28 68.06C219.28 85.7 233.58 100 251.22 100Z",
  fill: "#8DE1FF"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M237.24 60.13H247.07V65.32C247.068 65.3648 247.08 65.4092 247.104 65.447C247.128 65.4849 247.163 65.5146 247.204 65.532C247.246 65.5494 247.291 65.5537 247.335 65.5444C247.379 65.5352 247.419 65.5127 247.45 65.48C247.981 64.9979 248.673 64.7306 249.39 64.73C249.764 64.73 250.134 64.8038 250.479 64.9471C250.824 65.0905 251.138 65.3006 251.402 65.5653C251.666 65.8301 251.874 66.1444 252.017 66.4901C252.159 66.8358 252.231 67.2062 252.23 67.58C252.23 68.3341 251.931 69.0575 251.399 69.5917C250.866 70.1259 250.144 70.4274 249.39 70.43H247.18C247.166 70.4286 247.152 70.4302 247.139 70.4345C247.125 70.4389 247.113 70.4461 247.103 70.4555C247.092 70.4649 247.084 70.4764 247.078 70.4893C247.073 70.5021 247.07 70.516 247.07 70.53V87.09C247.07 87.27 247.07 87.44 247.07 87.61C247.012 88.551 246.611 89.438 245.941 90.1019C245.272 90.7658 244.381 91.1602 243.44 91.21C242.409 91.1431 241.446 90.6716 240.76 89.8981C240.075 89.1247 239.722 88.1119 239.78 87.08V82.58C238.961 82.7973 238.117 82.9082 237.27 82.91H236.68C234.227 82.91 231.874 81.9355 230.139 80.2007C228.404 78.466 227.43 76.1133 227.43 73.66V60.13H237.27H237.24Z",
  fill: "#0E3163"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M237.729 65.1899L240.499 65.1362C241.305 65.1206 241.946 64.4544 241.93 63.6482C241.915 62.842 241.248 62.2011 240.442 62.2167L237.673 62.2704C236.867 62.286 236.226 62.9522 236.241 63.7584C236.257 64.5646 236.923 65.2055 237.729 65.1899Z",
  fill: "white"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M229.261 65.0056L231.501 64.9622C232.307 64.9466 232.948 64.2804 232.932 63.4742C232.917 62.6681 232.25 62.0272 231.444 62.0428L229.205 62.0862C228.398 62.1018 227.758 62.768 227.773 63.5742C227.789 64.3804 228.455 65.0213 229.261 65.0056Z",
  fill: "white"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M233.21 65.63L232.58 65.97L232.31 66.12C232.187 66.1808 232.078 66.2663 231.99 66.371C231.901 66.4757 231.835 66.5975 231.796 66.7288C231.757 66.8601 231.745 66.9981 231.761 67.1342C231.777 67.2703 231.821 67.4016 231.89 67.52V67.52C231.952 67.642 232.038 67.75 232.143 67.8374C232.248 67.9248 232.37 67.9898 232.501 68.0282C232.633 68.0666 232.77 68.0777 232.906 68.0608C233.042 68.044 233.172 67.9994 233.29 67.93",
  stroke: "white",
  strokeWidth: 0.31,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M237.58 65.14C238.353 65.14 238.98 64.5132 238.98 63.74C238.98 62.9668 238.353 62.34 237.58 62.34C236.807 62.34 236.18 62.9668 236.18 63.74C236.18 64.5132 236.807 65.14 237.58 65.14Z",
  fill: "#1D1D1B"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M229.06 64.97C229.833 64.97 230.46 64.3432 230.46 63.57C230.46 62.7968 229.833 62.17 229.06 62.17C228.287 62.17 227.66 62.7968 227.66 63.57C227.66 64.3432 228.287 64.97 229.06 64.97Z",
  fill: "#1D1D1B"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M237.58 69.43C236.65 70.17 233.43 70.89 231.89 70.25",
  stroke: "white",
  strokeWidth: 0.31,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M239.52 243.61L239.82 300.31",
  stroke: "#0E3163",
  strokeWidth: 19.06,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M258.99 199.62L323.18 262.88",
  stroke: "#0E3163",
  strokeWidth: 19.06,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M258.99 199.62L309.88 251.06",
  stroke: "#2399E2",
  strokeWidth: 30.94,
  strokeMiterlimit: 10
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M262.37 141.77L258.99 199.62",
  stroke: "#2399E2",
  strokeWidth: 30.94,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M224.56 132H277.77V138.76C277.77 142.608 276.241 146.299 273.52 149.02C270.799 151.741 267.108 153.27 263.26 153.27H239.06C235.212 153.27 231.521 151.741 228.8 149.02C226.079 146.299 224.55 142.608 224.55 138.76V132H224.56Z",
  fill: "#38B8E0"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M235.18 206.18L236.11 277.3",
  stroke: "#38B8E0",
  strokeWidth: 30.94,
  strokeMiterlimit: 10
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M239.82 131.96L235.18 206.18",
  stroke: "#38B8E0",
  strokeWidth: 30.94,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M232.67 86.21H244.44C253.277 86.21 261.752 89.7205 268.001 95.9692C274.249 102.218 277.76 110.693 277.76 119.53V137.43H225.76C224.89 137.43 224.056 137.084 223.441 136.469C222.826 135.854 222.48 135.02 222.48 134.15V96.43C222.48 93.7247 223.553 91.1297 225.463 89.214C227.373 87.2982 229.965 86.218 232.67 86.21Z",
  fill: "#1F75DB"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M224.56 98.37C214.79 105.51 208.4 112.84 190.42 114.68",
  stroke: "#0E3163",
  strokeWidth: 14.69,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M182.64 67.09C182.64 66.17 182.7 65.25 182.8 64.34C182.86 63.8 183 63.16 183.51 62.98",
  stroke: "black",
  strokeWidth: 0.31,
  strokeMiterlimit: 10
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M181.8 67.27C179.37 62.82 177.8 49.47 170.26 50.69C164.84 51.56 170.31 67.11 170.85 71.79C171.3 75.6 173.38 75.88 176.73 76.22C180.08 76.56 184.21 71.68 181.8 67.27Z",
  fill: "#0E3163"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M182.64 57.04L183.51 72.35",
  stroke: "#0E3163",
  strokeWidth: 4.69,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M190.42 114.68C182.64 98.37 177.83 70.53 177.83 70.53",
  stroke: "#0E3163",
  strokeWidth: 14.69,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M240.892 104.353L220.029 116.398C219.202 116.875 218.22 117.004 217.297 116.757C216.375 116.51 215.589 115.907 215.111 115.08L208.006 102.774C207.529 101.947 207.4 100.964 207.647 100.042C207.894 99.1197 208.497 98.3334 209.324 97.856L226.108 88.166C228.012 87.0667 230.275 86.7688 232.398 87.3379C234.522 87.9069 236.333 89.2963 237.432 91.2004L242.197 99.4536C242.674 100.28 242.804 101.263 242.557 102.185C242.31 103.108 241.706 103.894 240.879 104.371L240.892 104.353Z",
  fill: "#1F75DB"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M250 293.31L251.41 311.11H198.5C198.5 306.73 231.15 297.02 231.15 291.9C237 296.5 242 297.31 248.64 293.9L250 293.31Z",
  fill: "#F2F2F2"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M218.11 300.31L228.27 287.17C228.442 286.947 228.667 286.77 228.924 286.655C229.181 286.54 229.463 286.49 229.744 286.509C230.025 286.529 230.296 286.618 230.535 286.768C230.773 286.918 230.971 287.125 231.11 287.37L233.65 291.84C233.837 292.166 233.948 292.53 233.978 292.904C234.007 293.279 233.952 293.655 233.818 294.006C233.684 294.357 233.474 294.674 233.203 294.934C232.932 295.194 232.606 295.391 232.25 295.51L218.11 300.31Z",
  fill: "#D8DADB"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M196.55 311H252.55L252.19 306.49C252.172 306.256 252.109 306.028 252.002 305.819C251.896 305.609 251.75 305.423 251.571 305.271C251.393 305.118 251.186 305.003 250.963 304.93C250.739 304.858 250.504 304.831 250.27 304.85L200.47 308.73C199.115 308.84 197.857 309.48 196.97 310.51L196.55 311Z",
  fill: "#D8DADB"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M328.66 253.49L342.25 265.08L335.61 271.72L333.68 273.65L304.84 302.49C301.74 299.39 317.96 269.43 314.34 265.81H314.4C321.79 264.93 325.9 261.96 328.21 254.88L328.66 253.49Z",
  fill: "#F2F2F2"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M311.08 281L309 264.51C308.964 264.231 308.997 263.948 309.097 263.685C309.196 263.423 309.359 263.189 309.571 263.004C309.782 262.819 310.036 262.689 310.31 262.625C310.583 262.562 310.869 262.567 311.14 262.64L316.14 264C316.501 264.1 316.836 264.278 317.12 264.522C317.405 264.766 317.632 265.07 317.786 265.412C317.939 265.754 318.016 266.125 318.01 266.5C318.004 266.875 317.915 267.243 317.75 267.58L311.08 281Z",
  fill: "#D8DADB"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M303.41 303.81L343 264.2L339.55 261.27C339.372 261.118 339.166 261.003 338.944 260.931C338.721 260.859 338.487 260.831 338.254 260.85C338.021 260.869 337.793 260.933 337.585 261.039C337.377 261.146 337.192 261.292 337.04 261.47L304.57 299.42C303.689 300.459 303.251 301.802 303.35 303.16L303.41 303.81Z",
  fill: "#D8DADB"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M110.34 102.6C110.09 102.49 109.85 102.37 109.6 102.28H109.54C108.77 101.72 107.961 101.216 107.12 100.77C106.091 100.203 104.952 99.8619 103.78 99.77C103.139 99.789 102.501 99.8796 101.88 100.04C101.63 100.11 101.45 100.19 101.73 100.31L102.73 100.89C103.364 101.285 104.033 101.62 104.73 101.89C105.326 102.031 105.938 102.098 106.55 102.09C106.816 102.057 107.087 102.085 107.34 102.174C107.593 102.262 107.823 102.408 108.01 102.6C107.777 102.432 107.513 102.313 107.233 102.249C106.953 102.186 106.663 102.179 106.38 102.23C105.768 102.291 105.149 102.251 104.55 102.11C103.801 101.88 103.069 101.596 102.36 101.26C102.18 101.26 102 101.38 101.82 101.45C101.64 101.52 101.37 101.73 101.69 101.82C102.671 102.171 103.673 102.461 104.69 102.69C105.252 102.736 105.817 102.705 106.37 102.6C106.603 102.53 106.849 102.522 107.086 102.576C107.323 102.631 107.541 102.746 107.72 102.91C107.441 103.302 107.307 103.78 107.34 104.26C104.34 103.74 103.34 103.47 102.7 103.34C102.059 103.274 101.415 103.439 100.885 103.805C100.355 104.172 99.9737 104.717 99.8101 105.34C99.7111 106.046 99.8904 106.763 100.31 107.34C100.68 107.826 101.081 108.287 101.51 108.72C101.543 108.909 101.543 109.101 101.51 109.29C101.51 109.49 101.78 109.69 101.93 109.7C102.08 109.71 103.8 110.27 103.8 110.27L106.47 111.1C106.47 111.1 106.47 110.92 106.52 110.85C106.516 110.644 106.439 110.446 106.304 110.291C106.169 110.136 105.983 110.033 105.78 110C104.86 109.73 104.69 109.67 104.5 109.61C104.31 109.55 104.5 109.61 104.63 109.45C104.893 109.226 105.108 108.95 105.26 108.64C105.413 108.296 105.481 107.919 105.456 107.543C105.432 107.167 105.316 106.802 105.12 106.48C105.411 106.832 105.611 107.252 105.7 107.7C105.746 108.007 105.728 108.32 105.647 108.619C105.566 108.919 105.424 109.198 105.23 109.44L105.62 109.56C105.62 109.56 108.16 107.01 108.4 106.74C108.61 106.529 108.872 106.377 109.16 106.3C109.762 106.122 110.345 105.885 110.9 105.59C111.126 105.378 111.312 105.127 111.45 104.85C111.537 104.714 111.592 104.56 111.61 104.4C111.504 104.211 111.384 104.03 111.25 103.86C111.001 103.371 110.662 102.933 110.25 102.57",
  fill: "white"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M103 110.46C102.971 110.477 102.945 110.499 102.924 110.526C102.904 110.552 102.889 110.583 102.88 110.616C102.872 110.649 102.87 110.683 102.875 110.716C102.88 110.749 102.892 110.781 102.91 110.81C102.933 110.858 102.972 110.897 103.02 110.92C103.22 111.02 103.87 110.66 103.87 110.66L103.2 110.45C103.135 110.43 103.065 110.43 103 110.45",
  fill: "white"
});

function SvgHighFive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 336,
    viewBox: "0 0 375 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75);
}

var ForwardRef = React.forwardRef(SvgHighFive);
export default __webpack_public_path__ + "static/media/high-five.4059eeb8.svg";
export { ForwardRef as ReactComponent };